const getters = {
  member: (state) => state.member,
  products: (state) => state.product,
  config: (state) => state.config,
};

export default getters;
